import { ChildApplicationDto } from '../models/bulk-progress.models';

/**
 * Excel Export Utility for Failed Applications Report
 */

export class BulkProgressExcelExporter {
  /**
   * Exports failed applications to CSV file
   */
  static exportFailedApplications(
    failedApplications: ChildApplicationDto[],
    masterApplicationNumber: string,
    labels: { identifier: string; errorMessage: string; noErrorMessage: string }
  ): void {
    // Create CSV content
    const headers = [labels.identifier, labels.errorMessage];
    const rows = failedApplications.map(app => [
      app.displayIdentifier,
      app.errorMessage || labels.noErrorMessage,
    ]);

    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.map(cell => this.escapeCsvCell(cell)).join(',')),
    ].join('\n');

    // Create and download file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute(
      'download',
      `failed-applications-${masterApplicationNumber}-${Date.now()}.csv`
    );
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }

  /**
   * Escape CSV cell content
   */
  private static escapeCsvCell(cell: string): string {
    if (cell.includes(',') || cell.includes('"') || cell.includes('\n')) {
      return `"${cell.replace(/"/g, '""')}"`;
    }
    return cell;
  }
}
